export const ROLE_SECTIONS = {
  admin: ["dashboard", "pipeline", "campaigns", "referrals", "calendar", "procedures", "communication", "drchrono", "staff", "messaging", "medications", "birthdays"],
  provider: ["calendar", "communication", "medications"],
  front_desk: ["pipeline", "calendar", "communication", "medications"],
};

export const ROLE_LABELS = {
  admin: "Owner / Admin",
  provider: "Provider",
  front_desk: "Front Desk",
};

export const SECTION_PATH = {
  dashboard: "/",
  pipeline: "/pipeline",
  campaigns: "/campaigns",
  referrals: "/referrals",
  calendar: "/calendar",
  procedures: "/procedures",
  communication: "/communication",
  drchrono: "/drchrono",
  staff: "/staff",
  messaging: "/messaging",
  medications: "/medications",
  birthdays: "/birthdays",
};

export function canAccess(role, section) {
  return (ROLE_SECTIONS[role] || ROLE_SECTIONS.front_desk).includes(section);
}

export function firstPath(role) {
  const s = (ROLE_SECTIONS[role] || ROLE_SECTIONS.front_desk)[0];
  return SECTION_PATH[s] || "/calendar";
}
